import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75033 7.91797C2.60449 7.91797 1.66699 8.85547 1.66699 10.0013C1.66699 11.1471 2.60449 12.0846 3.75033 12.0846C4.89616 12.0846 5.83366 11.1471 5.83366 10.0013C5.83366 8.85547 4.89616 7.91797 3.75033 7.91797Z",
			fill: "#EFEEF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2503 7.91797C15.1045 7.91797 14.167 8.85547 14.167 10.0013C14.167 11.1471 15.1045 12.0846 16.2503 12.0846C17.3962 12.0846 18.3337 11.1471 18.3337 10.0013C18.3337 8.85547 17.3962 7.91797 16.2503 7.91797Z",
			fill: "#EFEEF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.91699 10.0013C7.91699 8.85547 8.85449 7.91797 10.0003 7.91797C11.1462 7.91797 12.0837 8.85547 12.0837 10.0013C12.0837 11.1471 11.1462 12.0846 10.0003 12.0846C8.85449 12.0846 7.91699 11.1471 7.91699 10.0013Z",
			fill: "#EFEEF0"
		})
	]
});
export default SvgMoreIcon;
